import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Languages } from "lucide-react";
import { http, formatApiError } from "../lib/api";
import { syncLocale } from "../i18n";

export const DefaultLangCard = () => {
  const [lang, setLang] = useState(null);
  useEffect(() => { http.get("/brand").then((r) => setLang(r.data.default_lang || "fr")).catch(() => setLang("fr")); }, []);
  const save = async (v) => {
    try { await http.put("/settings/default-lang", { lang: v }); setLang(v); toast.success("Langue par défaut enregistrée"); syncLocale(); }
    catch (e) { toast.error(formatApiError(e)); }
  };
  if (!lang) return null;
  return (
    <div className="border border-slate-200 bg-white rounded-md p-6 mb-6" data-testid="default-lang-card">
      <div className="flex items-center gap-2 mb-2"><Languages className="h-5 w-5 text-sky-600" /><h2 className="font-display text-xl font-bold">Langue de l'application</h2></div>
      <p className="text-sm text-slate-600 mb-3">Langue de toute l'application pour votre société : utilisateurs, agents et pages publiques. La devise et le suivi des cartes professionnelles suivent le pays indiqué dans les informations société (France, Royaume-Uni, Suisse).</p>
      <div className="flex gap-2" data-no-i18n>
        {[["fr", "Français"], ["en", "English (UK)"]].map(([k, l]) => (
          <button key={k} type="button" onClick={() => save(k)} className={`px-4 py-2 rounded-md text-sm font-semibold border ${lang === k ? "bg-[#0B2A7A] text-white border-[#0B2A7A]" : "bg-white border-slate-300 text-slate-700"}`} data-testid={`default-lang-${k}`}>{l}</button>
        ))}
      </div>
    </div>
  );
};
